import React, { Component, Fragment } from 'react';



class Footer extends Component {
    
    render() {
        return (
            <Fragment>
                <div className="footer">
                    <p>Copyrights © Magnum Clothing Pvt Ltd {new Date().getFullYear()}. All Rights Reserved.</p>
                </div>

            </Fragment>
        );
    }
}

export default Footer;








// WEBPACK FOOTER //
// ./src/components/mainLayout/footer/component.js